// extracted by mini-css-extract-plugin
export default {"content":"bD5p51QIv0rEU6a7Mjrz","row":"lYAfLNcNqi0p6zAWhkV3"};